import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import PersonalizationTakes from './components/PersonalizationTakes'
import KeyFindings from './components/KeyFindings'
import AsDigitalSoars from './components/AsDigitalSoars'
import PersonalizationIsNoLongerAnOption from './components/PersonalizationIsNoLongerAnOption'
import BusinessesInvesting from './components/BusinessesInvesting'
import AttitudesTowardPrivacy from './components/AttitudesTowardPrivacy'
import TrustIsGoodBusiness from './components/TrustIsGoodBusiness'
import CustomersAreSplit from './components/CustomersAreSplit'
import PersonalizationStrategies from './components/PersonalizationStrategies'
import Guides from './components/Guides'
import PersonalizedExperiences from './components/PersonalizedExperiences'
import StrikingTheBalance from './components/StrikingTheBalance'
import PersonalizationAndPrivacy from './components/PersonalizationAndPrivacy'
import PotholesAlongTheCustomerJourney from './components/PotholesAlongTheCustomerJourney'
import TheOmnichannelImperative from './components/TheOmnichannelImperative'
import OmnichannelSuccess from './components/OmnichannelSuccess'
import OrchestrateIntelligentEngagement from './components/OrchestrateIntelligentEngagement'
import PersonalizeOrPerish from './components/PersonalizeOrPerish/PersonalizeOrPerish'
import GettingStarted from './components/GettingStarted'
import RecommendedReading from './components/RecommendedReading'

import ogImagePng from './assets/OgStateOfPersonalizationReport2021.png'

const StateOfPersonalizationReport2021 = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="2021 State of Personalization Report  | Twilio Segment"
        pageDescription="The State of Personalization report looks at how attitudes, preferences, and experiences with personalization have evolved over the past year. This report features survey data from 3,000+ businesses and consumers worldwide to explore expectations for digital experiences, data privacy, personalization, and more."
        pageOG={ogImagePng}
        themeColor={theme.palette.twilio.green[10]}
      >
        <Navigation />
        <Hero />
        <Main>
          <PersonalizationTakes />
          <KeyFindings />
          <AsDigitalSoars />
          <PersonalizationIsNoLongerAnOption />
          <BusinessesInvesting />
          <PersonalizationStrategies />
          <AttitudesTowardPrivacy />
          <TrustIsGoodBusiness />
          <CustomersAreSplit />
          <Guides />
          <PersonalizedExperiences />
          <StrikingTheBalance />
          <PersonalizationAndPrivacy />
          <PotholesAlongTheCustomerJourney />
          <TheOmnichannelImperative />
          <OmnichannelSuccess />
          <OrchestrateIntelligentEngagement />
          <PersonalizeOrPerish />
          <BottomBackground>
            <GettingStarted />
            <RecommendedReading />
          </BottomBackground>
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main``

export default StateOfPersonalizationReport2021

const BottomBackground = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-bottom: 80px;
  }
`
